import useResource from 'app/hooks/useResource';

import {
  getMembers,
  setMemberParams
} from 'app/actions/members';

import {
  createMember,
  updateMember,
  destroyMembers
} from 'app/services/members';

import {
  members as resource
} from 'app/resources';

const useMembers = () => {
  return useResource({
    resource,
    getResource: getMembers,
    createResource: createMember,
    updateResource: updateMember,
    destroyResource: destroyMembers,
    setResourceParams: setMemberParams
  });
}

export default useMembers;
